import { AuthService } from "./AuthService";
import { ApiService } from "./ApiService";
import { SERVICE_URL } from "../evironment";
import { UiService } from "./UiService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { ClientsService } from "./ClientsService";
import { ZonesService } from "./ZonesService";
import { ParkingService } from "./ParkingService";
import { CarService } from "./CarService";
import { ParkingStorageService } from "./ParkingStorageService";
const queryParamsFactory = new QueryParamsFactory();
const uiService = new UiService();
const apiService = new ApiService(SERVICE_URL, uiService);
const authService = new AuthService(apiService);
const parkingService = new ParkingService(apiService, queryParamsFactory);
const clientsService = new ClientsService(apiService, queryParamsFactory);
const zonesService = new ZonesService(apiService, queryParamsFactory);
const carService = new CarService(apiService, queryParamsFactory);
const parkingStorageService = new ParkingStorageService();
export { uiService, authService, parkingService, clientsService, zonesService, carService, parkingStorageService };
